// 用户反馈管理
import http from "@/jslibs/axios/http";

// 用户反馈详情
export const detail = (id) => http.get("/cms/rating/details/" + id);

// 用户反馈分页列表
export const page = (data) => http.get("/cms/rating/page", data);
